import React from "react";

const TicketIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8">
          <path
            d="M21.75 10.5C21.9489 10.5 22.1397 10.421 22.2803 10.2803C22.421 10.1397 22.5 9.94891 22.5 9.75V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934C21.7794 4.65804 21.3978 4.5 21 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V9.75C1.5 9.94891 1.57902 10.1397 1.71967 10.2803C1.86032 10.421 2.05109 10.5 2.25 10.5C2.64782 10.5 3.02936 10.658 3.31066 10.9393C3.59196 11.2206 3.75 11.6022 3.75 12C3.75 12.3978 3.59196 12.7794 3.31066 13.0607C3.02936 13.342 2.64782 13.5 2.25 13.5C2.05109 13.5 1.86032 13.579 1.71967 13.7197C1.57902 13.8603 1.5 14.0511 1.5 14.25V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V14.25C22.5 14.0511 22.421 13.8603 22.2803 13.7197C22.1397 13.579 21.9489 13.5 21.75 13.5C21.3522 13.5 20.9706 13.342 20.6893 13.0607C20.408 12.7794 20.25 12.3978 20.25 12C20.25 11.6022 20.408 11.2206 20.6893 10.9393C20.9706 10.658 21.3522 10.5 21.75 10.5ZM21 14.9025V18H15.75V15.75H14.25V18H3V14.9025C3.642 14.7347 4.21025 14.3588 4.61582 13.8336C5.02139 13.3084 5.24139 12.6636 5.24139 12C5.24139 11.3364 5.02139 10.6916 4.61582 10.1664C4.21025 9.64121 3.642 9.2653 3 9.0975V6H14.25V8.25H15.75V6H21V9.0975C20.358 9.2653 19.7898 9.64121 19.3842 10.1664C18.9786 10.6916 18.7586 11.3364 18.7586 12C18.7586 12.6636 18.9786 13.3084 19.3842 13.8336C19.7898 14.3588 20.358 14.7347 21 14.9025Z"
            fill={props?.color ?? "black"}
          />
          <path
            d="M14.25 9.75H15.75V14.25H14.25V9.75Z"
            fill={props?.color ?? "black"}
          />
        </g>
      </svg>
    </div>
  );
};

export default TicketIcon;
